import React, { useState, useEffect, FC } from "../../../lib/teact/teact";
import { IS_SAFARI } from "../../../util/windowEnvironment";
import ConfirmDialog from "../../ui/ConfirmDialog";


function isInStandaloneMode() {
    // Kiểm tra nếu đã cài rồi
    return 'standalone' in window.navigator && (window.navigator as any).standalone;
}

let deferredPrompt: any = null;

const InstallPWAButton: React.FC = () => {
    const [showInstall, setShowInstall] = useState(false);
    const [isIOS, setIsIOS] = useState(false);
    const [state, setState] = useState({
        showDialog: false,
    })
    useEffect(() => {
        if (IS_SAFARI && !isInStandaloneMode()) {
            setIsIOS(true);
            setShowInstall(true);
        }

        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            deferredPrompt = e;
            setShowInstall(true);
        });
    }, []);

    const handleClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const result = await deferredPrompt.userChoice;
            console.log(result.outcome);
            deferredPrompt = null;
            setShowInstall(false);
        } else if (IS_SAFARI) {
            setState({ ...state, showDialog: true });
        }
    };

    if (!showInstall) return null;

    return (
        <div>
            <button onClick={handleClick}>
                📲 Cài ứng dụng
            </button>
            <ConfirmDialog isOpen={state.showDialog}
                onClose={() => setState({ ...state, showDialog: false })}
                confirmHandler={() => {
                    setState({ ...state, showDialog: false });

                }}
                title="Cài ứng dụng trên iOS"
            >
                <div style={{ width: '100%', maxWidth: '500px', maxHeight: '400px', overflow: 'auto' }}>
                    Để cài ứng dụng: Nhấn nút 'Chia sẻ'
                    <svg width="24" height="24" viewBox="0 0 24 24"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 3v9"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9 6l3-3 3 3"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    trên Safari → chọn 'Thêm vào Màn hình chính → đặt tên → chọn "Thêm" (góc phải trên cùng)'
                    {/* <img src={installImage} alt="Logo"
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '60vh',
                            objectFit: 'contain'
                        }} /> */}

                </div>
            </ConfirmDialog>
        </div>
    );
};

export default InstallPWAButton;